import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';

import { getUserDetail } from '../../actions/adminActions';

import AddUser from '../../components/admin/user/UserDetails/AddUser';

class EditUserContainer extends Component {
  static propTypes = {
    adminAccounts: PropTypes.instanceOf(Object),
    params: PropTypes.instanceOf(Object),
  }

  static defaultProps = {
    adminAccounts: {},
    params: {},
  };

  state = {
    isEmailDisabled: true,
    userDetails: '',
  }

  componentDidMount() {
    const { params, adminAccounts } = this.props;
    if (adminAccounts && adminAccounts.data) {
      getUserDetail(params.userId)
      .then(response => {
        if (response) {
          this.setState({
            userDetails: {
              ...response,
              selectedAccount: response.accountUsers,
              firstName: response.firstName || '',
              lastName: response.lastName || '',
              emailLogin: response.emailLogin || '',
              phoneNumber: response.phoneNumber || '',
              status: response.status || '',
            },
          });
        }
      });
    }
  }

  render() {
    const { adminAccounts } = this.props;
    const { userDetails, isEmailDisabled } = this.state;
    return (
      <div className="admin-body usersearch-body">
        {userDetails && adminAccounts.data && (
          <AddUser
            isEmailDisabled={isEmailDisabled}
            userDetails={userDetails}
          />
        )}
      </div>
    );
  }
}


const mapStateToProps = ({ admin }) => ({
  adminAccounts: admin.adminAccounts,
});

export default connect(mapStateToProps)(EditUserContainer);

